import React, { useEffect, useState } from 'react';
import {
  ACCORDION_WO_ICON,
  ACCORDION_W_ICON,
  BUTTON_W_CTA,
  CAROUSEL_LANDSCAPE_W_BG,
  CAROUSEL_LANDSCAPE_W_BODY_CTA,
  CAROUSEL_LARGE_IMG_W_BG,
  CAROUSEL_PORTRAIT_W_BG,
  CAROUSEL_SOCIAL,
  CAROUSEL_WO_BG,
  DETAIL_PAGE,
  HERO_BANNER_W_CTA,
  HERO_BANNER_W_SUBTITLE_CTA,
  HERO_BANNER_W_TITLE,
  IMAGE_LARGE,
  IMAGE_LARGE_W_BG,
  IMAGE_LARGE_W_TITLE_BODY,
  IMAGE_LARGE_W_TITLE_SUBTITLE_BODY,
  IMAGE_W_TITLE_BODY,
  LIST_COMPONENT,
  SERVICE_DETAIL_COMPONENT,
  SMALL_BANNER_W_TITLE,
  BUTTON_W_ICON,
  BASIC_TEXT_COMPONENT,
  CAROUSEL_W_DESCRIPTION,
} from '../../constants/UiBuilderConst';
import CustomAccordion from '../../shared/custom-accordion/Custom-Accordion';
import AccordionWithIcon from './component-library/accordian-with-icon/Accordion-With-Icon';
import AccordionWithoutIcon from './component-library/accordion-without-icon/Accordion-Without-Icon';
import CarouselSocialComponent from './component-library/carousel-social-component/Carousel-Social-Component';
import CarouselWithoutBackground from './component-library/carousel-without-background/Carousel-Without-Background';
import CtaButton1 from './component-library/cta-button-1/Cta-Button-1';
import DetailPage from './component-library/detail-view/Detail-View';
import HeroBannerWithCTA from './component-library/hero-banner-with-cta/Hero-Banner-With-CTA';
import HeroBannerWithTitleAndCTA from './component-library/hero-banner-with-title-and-cta/Hero-Banner-With-Title-And-CTA';
import HeroBannerWithTitle from './component-library/hero-banner-with-title/Hero-Banner-With-Title';
import ImageComponentWithTitleAndBody from './component-library/image-component-with-title-and-body/Image-Component-With-Title-And-Body';
import LandscapeCarouselWithBackground from './component-library/landscape-carousel-with-background/Landscape-Carousel-With-Background';
import LandscapeCarouselWithBodyCta from './component-library/landscape-carousel-with-body-cta/Landscape-Carousel-With-Body-Cta';
import LargeImageCarouselWithBackground from './component-library/large-image-carousel-with-background/Large-Image-Carousel-With-Background';
import LargeImageComponentWithBackground from './component-library/large-image-component-with-background/Large-Image-Component-With-Background';
import LargeImageComponentWithBody from './component-library/large-image-component-with-body/Large-Image-Component-With-Body';
import LargeImageComponentWithTitleSubtitleBody from './component-library/large-image-component-with-title-subtitle-body/Large-Image-Component-With-Title-Subtitle-Body';
import LargeImageComponent from './component-library/large-image-component/Large-Image-Component';
import ListComponent from './component-library/list-component/List-Component';
import PortraitCarousalWithBackground from './component-library/portrait-carousal-with-background/Portrait-Carousal-With-Background';
import ServiceDetailPage from './component-library/service-detail-page/Service-Detail-Page';
import SmallBannerWithTitle from './component-library/small-banner-with-title/Small-Banner-With-Title';
import { getComponentTitle } from '../../utils/UiBuilderUtils';
import { useSelector } from 'react-redux';
import {
  allAmenitiesSelector,
  allRestaurantSelector,
  allRoomTypesSelector,
  allSpaInfoSelector,
} from '../../layouts/property/propertySlice';
import { offerSelector } from '../../layouts/cms/cmsSlice';
import ButtonWithIcon from './component-library/button-with-icon/Button-With-Icon';
import BasicComponentText from './component-library/basic-component-text/Basic-Component-Text';
import CarouselWithDescription from './component-library/carousel-with-description/Carousel-With-Description';

const UiBuilderCommonComponent = (props) => {
  const {
    onItemChange,
    component,
    groupId,
    handleError,
    componentNdx,
    componentExpandStatus,
    toggleExpandedStatus,
  } = props;
  const [componentTitle, setCompponentTitle] = useState();
  const [componentConfig, setComponentConfig] = useState(null);
  const allRestaurantoptions = useSelector(allRestaurantSelector);
  const allSpaOptions = useSelector(allSpaInfoSelector);
  const allRoomsOptions = useSelector(allRoomTypesSelector);
  const allAmenitiesOptions = useSelector(allAmenitiesSelector);
  const allOffers = useSelector(offerSelector);

  useEffect(() => {
    let config = { ...component.config };
    if (
      config &&
      config.slides &&
      config.slides.length > 0 &&
      config.hotelModule &&
      component.id !== IMAGE_W_TITLE_BODY
    ) {
      let optionsList = [];
      switch (config.hotelModule) {
        case 'ROOMS':
          optionsList = allRoomsOptions.filter((item) => item.isActive);
          break;
        case 'RESTAURANT':
          optionsList = allRestaurantoptions.filter((item) => item.isActive);
          break;
        case 'WELLNESS':
          optionsList = allSpaOptions.filter((item) => item.isActive);
          break;
        case 'EXPERIENCES':
          optionsList = [];
          break;
        case 'AMENITY':
          optionsList = allAmenitiesOptions.filter((item) => item.isActive);
          break;
        case 'OFFERS':
          optionsList = allOffers.filter((item) => item.status === 'Live');
          break;
        default:
          optionsList = [];
          break;
      }

      if (optionsList.length > 0) {
        const filteredSlides = config.slides.filter(
          (slide) =>
            slide.hotelModuleId === '' ||
            optionsList.some((item) => item.id === slide.hotelModuleId),
        );
        config.slides = filteredSlides;
      }
    }

    if (
      config &&
      config.slides &&
      config.slides.length > 0 &&
      config.hotelModule &&
      component.id === IMAGE_W_TITLE_BODY
    ) {
      let optionsList = [];
      switch (config.hotelModule) {
        case 'ROOMS':
          optionsList = allRoomsOptions.filter((item) => item.isActive);
          break;
        case 'RESTAURANT':
          optionsList = allRestaurantoptions.filter((item) => item.isActive);
          break;
        case 'WELLNESS':
          optionsList = allSpaOptions.filter((item) => item.isActive);
          break;
        case 'EXPERIENCES':
          optionsList = [];
          break;
        case 'AMENITY':
          optionsList = allAmenitiesOptions.filter((item) => item.isActive);
          break;
        case 'OFFERS':
          optionsList = allOffers.filter((item) => item.status === 'Live');
          break;
        default:
          optionsList = [];
          break;
      }

      if (optionsList.length > 0) {
        const filteredSlides = config.slides.map((slide) => {
          return {
            ...slide,
            hotelModuleId:
              slide.hotelModuleId === '' ||
              optionsList.some((item) => item.id === slide.hotelModuleId)
                ? slide.hotelModuleId
                : '',
            titleH3:
              slide.hotelModuleId === '' ||
              optionsList.some((item) => item.id === slide.hotelModuleId)
                ? slide.titleH3
                : '',
          };
        });
        config.slides = filteredSlides;
      }
    }

    setComponentConfig(config);
  }, [component.config]);

  useEffect(() => {
    if (component.title) {
      setCompponentTitle(component.title);
    } else {
      setCompponentTitle(getComponentTitle(component.id));
    }
  }, [component.title, component.id]);

  const switchComponent = () => {
    switch (component.id) {
      case CAROUSEL_PORTRAIT_W_BG:
        return (
          <PortraitCarousalWithBackground
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case CAROUSEL_LANDSCAPE_W_BG:
        return (
          <LandscapeCarouselWithBackground
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case CAROUSEL_W_DESCRIPTION:
        return (
          <CarouselWithDescription
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case CAROUSEL_WO_BG:
        return (
          <CarouselWithoutBackground
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case CAROUSEL_LARGE_IMG_W_BG:
        return (
          <LargeImageCarouselWithBackground
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case IMAGE_W_TITLE_BODY:
        return (
          <ImageComponentWithTitleAndBody
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case IMAGE_LARGE_W_TITLE_BODY:
        return (
          <LargeImageComponentWithBody
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case IMAGE_LARGE_W_BG:
        return (
          <LargeImageComponentWithBackground
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case IMAGE_LARGE:
        return (
          <LargeImageComponent
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case IMAGE_LARGE_W_TITLE_SUBTITLE_BODY:
        return (
          <LargeImageComponentWithTitleSubtitleBody
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case HERO_BANNER_W_CTA:
        return (
          <HeroBannerWithCTA
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case HERO_BANNER_W_SUBTITLE_CTA:
        return (
          <HeroBannerWithTitleAndCTA
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case HERO_BANNER_W_TITLE:
        return (
          <HeroBannerWithTitle
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case SMALL_BANNER_W_TITLE:
        return (
          <SmallBannerWithTitle
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case ACCORDION_W_ICON:
        return (
          <AccordionWithIcon
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case ACCORDION_WO_ICON:
        return (
          <AccordionWithoutIcon
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case BUTTON_W_CTA:
        return (
          <CtaButton1
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case BUTTON_W_ICON:
        return (
          <ButtonWithIcon
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case CAROUSEL_LANDSCAPE_W_BODY_CTA:
        return (
          <LandscapeCarouselWithBodyCta
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case CAROUSEL_SOCIAL:
        return (
          <CarouselSocialComponent
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case LIST_COMPONENT:
        return (
          <ListComponent
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case DETAIL_PAGE:
        return (
          <DetailPage
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case SERVICE_DETAIL_COMPONENT:
        return (
          <ServiceDetailPage
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      case BASIC_TEXT_COMPONENT:
        return (
          <BasicComponentText
            groupId={groupId}
            config={componentConfig}
            onItemChange={onItemChange}
            handleError={handleError}
            componentNdx={componentNdx}
          />
        );
      default:
        return <div></div>;
    }
  };

  return (
    <CustomAccordion
      header={componentTitle}
      expanded={componentExpandStatus[componentNdx]}
      shadow={true}
      hasDragSort={true}
      titleStyles={'component-title'}
      toggleExpandedStatus={toggleExpandedStatus}
      componentExpandStatus={componentExpandStatus}
      componentNdx={componentNdx}
    >
      {componentConfig && switchComponent()}
    </CustomAccordion>
  );
};

export default UiBuilderCommonComponent;
